


















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ListOrderPenunjang from "@/components/pemeriksaan/penunjang/ListOrderPenunjang.vue";
import InputOrderPenunjang from "@/components/pemeriksaan/penunjang/InputOrderPenunjang.vue";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
import CardListPenunjang from "@/components/kunjunganPasien/CardListPenunjang.vue";

@Component({
  components: {
    ListOrderPenunjang,
    InputOrderPenunjang,
    CardListPenunjang
  }
})
export default class CardOrder extends Vue {
  @Prop() orderItems: Array<object>;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() dataOrder!: Array<object>;
  @Prop() detailOrder!: object;
  @Prop() type!: string;
  @Prop() paste: Array<object>;
  @Prop() statusPaste: string;
  @Prop({ default: false }) readOnly!: boolean;

  tglIsi = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  tglShow = false;
  maxDate = new Date().toISOString().substr(0, 10);
  tab = "history-hasil";
  list;

  mounted() {
    const max = new Date(new Date().setDate(new Date().getDate() + 2));
    this.maxDate = max.toISOString().substring(0, 10);
  }
  get stateuser() {
    return userModule.user;
  }
  get listRo() {
    return storePenunjang.listhasilRadiologi;
  }

  getTabDaftar() {
    if (this.type == "lab") {
      storePenunjang.act_all_order_lab_by_reg(this.register);
    }

    if (this.type == "ro") {
      storePenunjang.act_all_order_radiologi_by_reg(this.register);
    }
  }

  getTabCreate() {
    // alert("baru")
    this.detailOrder = {};
    // storePenunjang.act_order_lab_byId(this.detailOrder['id'])
  }

  get listLab() {
    return storePenunjang.listhasilLab;
  }

  getTabHistory() {
    // get history hasil

    if (this.type == "ro") {
      storePenunjang.clear_list_ro();
      storePenunjang.act_list_ro_byRm(this.rm);
    } else {
      const param = {
        rm: this.rm,
        masuk: "",
        keluar: ""
      };
      storePenunjang.clear_list_lab();
      storePenunjang.act_list_lab_byRm(param);
    }
  }
  detailHasil(val) {
    if (val["tipe"] == "ro") {
      storePenunjang.clear_hasil_ro();
      storePenunjang.act_hasil_ro_byReg(val);
    } else {
      // storePenunjang.act_hasil_lab_byTrans();
      // console.log("Hasil LAb");
    }
  }

  showItemModal(v) {
    this.$emit("show-item-modal", v);
  }

  showTab(item) {
    this.getTabDaftar();
    this.tab = item;
  }

  showTabEditOrder(value) {
    this.tab = value["page"];
    this.$emit("sendIdOrder", value);
  }

  buatOrder() {
    this.tab = "buat-order";
  }

  setOrderItems(items) {
    this.$emit("set-order-items", items);
  }

  showOrderList() {
    this.tab = "daftar-order";
  }

  alasanBatal(value) {
    this.$emit("alasanBatal", value);
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  backPageSoap() {
    this.$emit("pageTab", "tab-soap");
  }
}
